// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".greenBtn[data-v-5604c08e]{color:#1da373;cursor:pointer}.edit[data-v-5604c08e]{color:#72ddff;cursor:pointer}.playback[data-v-5604c08e]{color:#2289f6;cursor:pointer}.delete[data-v-5604c08e]{color:#ff9e9e;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
